// The contact book's server state. A domain's register and contacts forms will read
// contactListQuery to pick from (guide, rule 25), so this is the feature's public surface.
import { queryOptions } from "@tanstack/react-query";
import { getContact, listContacts } from "./api";

export const contactKeys = {
  all: ["contacts"] as const,
  lists: () => [...contactKeys.all, "list"] as const,
  list: (page: number) => [...contactKeys.lists(), page] as const,
  detail: (contactId: string) => [...contactKeys.all, "detail", contactId] as const,
};

/** One page of the contact book, newest first, with the page meta. */
export const contactListQuery = (page: number) =>
  queryOptions({ queryKey: contactKeys.list(page), queryFn: () => listContacts(page) });

export const contactQuery = (contactId: string) =>
  queryOptions({ queryKey: contactKeys.detail(contactId), queryFn: async () => (await getContact(contactId)).data });
